import React from 'react';
const BreadcrumbItem = ({ children, ...props }) => (
  <li className="breadcrumb-item" {...props}>
    {children}
  </li>
);

const Breadcrumb = props => {
  let children = React.Children.toArray(props.children);

  children = children.map((child, index) => (
    <BreadcrumbItem
      {...(props.ariaLabel && index == children.length - 1
        ? { 'aria-current': true }
        : '')}
      key={`breadcrumb_item${index}`}
    >
      {child}
    </BreadcrumbItem>
  ));

  return (
    <nav
      className="mainBreadcrumb"
      role="navigation"
      aria-label={props.ariaLabel ? props.ariaLabel : 'Breadcrumb'}
    >
      <ul>{children}</ul>
    </nav>
  );
};

export default Breadcrumb;
